import { delay, NAVIGATION_SETTLE_MS } from '../domLocator'
import { ClientTool, studentPageRequested } from '../Tool'

interface Input extends Record<string, unknown> {
  appUserId: number
  planId: string
}

const navigateToPlan: ClientTool = {
  name: 'navigate_to_plan',
  category: 'navigate',
  execute: async (rawInput, ctx) => {
    const { appUserId, planId } = rawInput as Input
    ctx.navigate(`/students/${appUserId}/plans/${planId}`)
    await delay(NAVIGATION_SETTLE_MS)
    return studentPageRequested(ctx.getPathname())
  },
  getStepLabel: () => 'Navigating to plan…'
}

export default navigateToPlan
